import { Box, Button } from '@mui/material';
import { t } from 'i18next';
import { Icon } from '@sdb/planning-ui';

type SearchButtonProps = {
  onSearch: () => void;
  disabled?: boolean;
};

const SearchButton = ({ onSearch, disabled }: SearchButtonProps) => {
  return (
    <Box maxWidth={200}>
      <Button
        variant="contained"
        sx={{ width: 'fit-content' }}
        color="primary"
        disabled={disabled}
        onClick={() => {
          onSearch();
        }}
      >
        <Icon
          type="magnifying-glass"
          fontSize="small"
          sx={{ m: 'auto', mr: 2 }}
        />
        {t('search')}
      </Button>
    </Box>
  );
};

export default SearchButton;
